import _ from 'lodash';
export const zubi = [
    { id: 18, rbr: 1, celjust: 'G' },
    { id: 17, rbr: 2, celjust: 'G' },
    { id: 16, rbr: 3, celjust: 'G' },
    { id: 15, rbr: 4, celjust: 'G' },
    { id: 14, rbr: 5, celjust: 'G' },
    { id: 13, rbr: 6, celjust: 'G' },
    { id: 12, rbr: 7, celjust: 'G' },
    { id: 11, rbr: 8, celjust: 'G' },

    { id: 21, rbr: 9, celjust: 'G' },
    { id: 22, rbr: 10, celjust: 'G' },
    { id: 23, rbr: 11, celjust: 'G' },
    { id: 24, rbr: 12, celjust: 'G' },
    { id: 25, rbr: 13, celjust: 'G' },
    { id: 26, rbr: 14, celjust: 'G' },
    { id: 27, rbr: 15, celjust: 'G' },
    { id: 28, rbr: 16, celjust: 'G' },

    { id: 48, rbr: 1, celjust: 'D' },
    { id: 47, rbr: 2, celjust: 'D' },
    { id: 46, rbr: 3, celjust: 'D' },
    { id: 45, rbr: 4, celjust: 'D' },
    { id: 44, rbr: 5, celjust: 'D' },
    { id: 43, rbr: 6, celjust: 'D' },
    { id: 42, rbr: 7, celjust: 'D' },
    { id: 41, rbr: 8, celjust: 'D' },

    { id: 31, rbr: 9, celjust: 'D' },
    { id: 32, rbr: 10, celjust: 'D' },
    { id: 33, rbr: 11, celjust: 'D' },
    { id: 34, rbr: 12, celjust: 'D' },
    { id: 35, rbr: 13, celjust: 'D' },
    { id: 36, rbr: 14, celjust: 'D' },
    { id: 37, rbr: 15, celjust: 'D' },
    { id: 38, rbr: 16, celjust: 'D' }
];

export const veze = [
    { id: 1, celjust: 'G', pozicija: 1817 },
    { id: 2, celjust: 'G', pozicija: 1716 },
    { id: 3, celjust: 'G', pozicija: 1615 },
    { id: 4, celjust: 'G', pozicija: 1514 },
    { id: 5, celjust: 'G', pozicija: 1413 },
    { id: 6, celjust: 'G', pozicija: 1312 },
    { id: 7, celjust: 'G', pozicija: 1211 },
    { id: 8, celjust: 'G', pozicija: 1121 },
    { id: 9, celjust: 'G', pozicija: 2122 },
    { id: 10, celjust: 'G', pozicija: 2223 },
    { id: 11, celjust: 'G', pozicija: 2324 },
    { id: 12, celjust: 'G', pozicija: 2425 },
    { id: 13, celjust: 'G', pozicija: 2526 },
    { id: 14, celjust: 'G', pozicija: 2627 },
    { id: 15, celjust: 'G', pozicija: 2728 },

    { id: 1, celjust: 'D', pozicija: 4847 },
    { id: 2, celjust: 'D', pozicija: 4746 },
    { id: 3, celjust: 'D', pozicija: 4645 },
    { id: 4, celjust: 'D', pozicija: 4544 },
    { id: 5, celjust: 'D', pozicija: 4443 },
    { id: 6, celjust: 'D', pozicija: 4342 },
    { id: 7, celjust: 'D', pozicija: 4241 },
    { id: 8, celjust: 'D', pozicija: 4131 },
    { id: 9, celjust: 'D', pozicija: 3132 },
    { id: 10, celjust: 'D', pozicija: 3233 },
    { id: 11, celjust: 'D', pozicija: 3334 },
    { id: 12, celjust: 'D', pozicija: 3435 },
    { id: 13, celjust: 'D', pozicija: 3536 },
    { id: 14, celjust: 'D', pozicija: 3637 },
    { id: 15, celjust: 'D', pozicija: 3738 }
];

export function findZub(id) {
    const item = _.find(zubi, { id: id });
    return item;
}

export function findVeza(id, celjust) {
    const item = _.find(veze, { id: id, celjust: celjust });
    return item;
}

export function findVezaByPozicija(pozicija) {
    const item = _.find(veze, { pozicija: pozicija });
    return item;
}



// WEBPACK FOOTER //
// ./app/components/radniNalog/zubi.svg.js